import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _forEach from "lodash/forEach";

import styled from "styled-components";
import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";
import dateFormatter from "modules/utils/DateFormatter";
import widgetConversions from "modules/utils/widgetConversions";
import Input from "components/facebook/Input";
import Button from "components/Buttons";
import Row from "components/Row";
import Toast from "components/Toast";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import formatValue from "modules/utils/formatValue";
import { format } from "path";

const ValidatedInput = ({ widgetName, validationFailed, value, onChange, onBlur }) => {
  return (
    <InputInTable
      className={validationFailed ? "boxError" : ""}
      type="text"
      full
      placeHolder="0.00"
      name={`${widgetName.toLowerCase()}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={(e) => onBlur(e.target.value)}
      margin="10px 0px !important"
    />
  );
};

const OfflineConversionWidget = () => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  const rwidgetConversionDefaultValueResult = useSelector((state) =>
    facebookSelectors.rwidgetConversionDefaultValueResult(state),
  );
  const [totalActionLastsend, setTotalActionLastsend] = useState(false);
  const [smartConversionLastsend, setSmartConversionLastsend] = useState(false);
  const [callbackLastsend, setCallbackLastsent] = useState(false);
  const [googleMapsLastsend, setGoogleMapsLastsent] = useState(false);
  const [zaloLastsend, setZaloLastsent] = useState(false);
  const [skypeLastsend, setSkypeLastsent] = useState(false);
  const [whatsappLastsend, setWhatsappLastsent] = useState(false);
  const [facebookLastsend, setFacebookLastsent] = useState(false);
  const [lineLastsend, setLineLastsent] = useState(false);
  const [phoneCallLastsend, setPhoneCallLastsent] = useState(false);
  const [contactFormLastsend, setContactFormLastsent] = useState(false);
  const [rChatLastsend, setRChatLastsent] = useState(false);
  const [customButtonLastsend, setCustomButtonLastsent] = useState(false);

  const [inputContactFrom, setInputContactFrom] = useState("0.00");
  const [inputLine, setInputLine] = useState("0.00");
  const [inputFacebookMessenger, setInputFacebookMessenger] = useState("0.00");
  const [inputPhoneCall, setInputPhoneCall] = useState("0.00");
  const [inputCallbackForm, setInputCallbackForm] = useState("0.00");
  const [inputWhatApp, setInputWhatApp] = useState("0.00");
  const [inputSkype, setInputSkype] = useState("0.00");
  const [inputGoogleMaps, setInputGoogleMaps] = useState("0.00");
  const [inputZalo, setInputZalo] = useState("0.00");
  const [inputRchat, setInputRchat] = useState("0.00");
  const [inputCustomButton, setInputCustomButton] = useState("0.00");
  const [inputTotalAction, setInputTotalAction] = useState("0.00");
  const [inputSmartConversion, setInputSmartConversion] = useState("0.00");

  const [validateContactFormFailed, setValidateContactFormFailed] = useState(false);
  const [validateLineFailed, setValidateLineFailed] = useState(false);
  const [validateFacebookMessengerFailed, setValidateFacebookMessengerFailed] = useState(false);
  const [validatePhoneCallFailed, setValidatePhoneCallFailed] = useState(false);
  const [validateCallBackFormFailed, setValidateCallBackFormFailed] = useState(false);
  const [validateWhatAppFailed, setValidateWhatAppFailed] = useState(false);
  const [validateSkypeFailed, setValidateSkypeFailed] = useState(false);
  const [validateGoogleMapFailed, setValidateGoogleMapFailed] = useState(false);
  const [validateZaloFailed, setValidateZaloFailed] = useState(false);
  const [validateRchatFailed, setValidateRchatFailed] = useState(false);
  const [validateCustomButtonFailed, setValidateCustomButtonFailed] = useState(false);
  const [validateTotalActionFailed, setValidateTotalActionFailed] = useState(false);
  const [validateSmartConversionFailed, setValidateSmartConversionFailed] = useState(false);

  const rmpToken = sessionStorage.getItem("rmp_token");
  const [loading, setLoading] = useState(false);
  const [adsKeyword, setAdsKeyword] = useState("");
  const [pageLoading, setPageLoading] = useState(true);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [showValidateFailedToast, setShowValidateFailedToast] = useState(false);
  const [submitFBWidgetLoading, setSubmitFBWidgetLoading] = useState(false);
  const dispatch = useDispatch();

  const widgetConversionsList = widgetConversions.getConversions(t);

  widgetConversionsList["RWidget-CallbackForm"].lastSend = callbackLastsend;
  widgetConversionsList["RWidget-GoogleMaps"].lastSend = googleMapsLastsend;
  widgetConversionsList["RWidget-Zalo"].lastSend = zaloLastsend;
  widgetConversionsList["RWidget-Skype"].lastSend = skypeLastsend;
  widgetConversionsList["RWidget-WhatsApp"].lastSend = whatsappLastsend;
  widgetConversionsList["RWidget-FacebookMessenger"].lastSend = facebookLastsend;
  widgetConversionsList["RWidget-LINE"].lastSend = lineLastsend;
  widgetConversionsList["RWidget-PhoneCall"].lastSend = phoneCallLastsend;
  widgetConversionsList["RWidget-ContactForm"].lastSend = contactFormLastsend;
  widgetConversionsList["RWidget-RChat"].lastSend = rChatLastsend;
  widgetConversionsList["RWidget-CustomButton"].lastSend = customButtonLastsend;

  widgetConversionsList["RWidget-CallbackForm"].name = "RWidget-CallbackForm";
  widgetConversionsList["RWidget-GoogleMaps"].name = "RWidget-GoogleMaps";
  widgetConversionsList["RWidget-Zalo"].name = "RWidget-Zalo";
  widgetConversionsList["RWidget-Skype"].name = "RWidget-Skype";
  widgetConversionsList["RWidget-WhatsApp"].name = "RWidget-WhatsApp";
  widgetConversionsList["RWidget-FacebookMessenger"].name = "RWidget-FacebookMessenger";
  widgetConversionsList["RWidget-LINE"].name = "RWidget-LINE";
  widgetConversionsList["RWidget-PhoneCall"].name = "RWidget-PhoneCall";
  widgetConversionsList["RWidget-ContactForm"].name = "RWidget-ContactForm";
  widgetConversionsList["RWidget-RChat"].name = "RWidget-RChat";
  widgetConversionsList["RWidget-CustomButton"].name = "RWidget-CustomButton";

  widgetConversionsList["RWidget-CallbackForm"].error = false;
  widgetConversionsList["RWidget-GoogleMaps"].error = false;
  widgetConversionsList["RWidget-Zalo"].error = false;
  widgetConversionsList["RWidget-Skype"].error = false;
  widgetConversionsList["RWidget-WhatsApp"].error = false;
  widgetConversionsList["RWidget-FacebookMessenger"].error = false;
  widgetConversionsList["RWidget-LINE"].error = false;
  widgetConversionsList["RWidget-PhoneCall"].error = false;
  widgetConversionsList["RWidget-ContactForm"].error = false;
  widgetConversionsList["RWidget-RChat"].error = false;
  widgetConversionsList["RWidget-CustomButton"].error = false;

  const facebookConversionLastSent = useSelector((state) =>
    facebookSelectors.getFacebookConversionLastSentResult(state),
  );

  const conversionMappings = {
    "RWidget-TotalActions": {
      setLastSent: setTotalActionLastsend,
      setInput: setInputTotalAction,
      setValidateFailed: setValidateTotalActionFailed,
    },
    "RWidget-SmartConversions": {
      setLastSent: setSmartConversionLastsend,
      setInput: setInputSmartConversion,
      setValidateFailed: setValidateSmartConversionFailed,
    },
    "RWidget-CallbackForm": {
      setLastSent: setCallbackLastsent,
      setInput: setInputCallbackForm,
      setValidateFailed: setValidateCallBackFormFailed,
    },
    "RWidget-GoogleMaps": {
      setLastSent: setGoogleMapsLastsent,
      setInput: setInputGoogleMaps,
      setValidateFailed: setValidateGoogleMapFailed,
    },
    "RWidget-Zalo": {
      setLastSent: setZaloLastsent,
      setInput: setInputZalo,
      setValidateFailed: setValidateZaloFailed,
    },
    "RWidget-Skype": {
      setLastSent: setSkypeLastsent,
      setInput: setInputSkype,
      setValidateFailed: setValidateSkypeFailed,
    },
    "RWidget-WhatsApp": {
      setLastSent: setWhatsappLastsent,
      setInput: setInputWhatApp,
      setValidateFailed: setValidateWhatAppFailed,
    },
    "RWidget-FacebookMessenger": {
      setLastSent: setFacebookLastsent,
      setInput: setInputFacebookMessenger,
      setValidateFailed: setValidateFacebookMessengerFailed,
    },
    "RWidget-LINE": {
      setLastSent: setLineLastsent,
      setInput: setInputLine,
      setValidateFailed: setValidateLineFailed,
    },
    "RWidget-PhoneCall": {
      setLastSent: setPhoneCallLastsent,
      setInput: setInputPhoneCall,
      setValidateFailed: setValidatePhoneCallFailed,
    },
    "RWidget-ContactForm": {
      setLastSent: setContactFormLastsent,
      setInput: setInputContactFrom,
      setValidateFailed: setValidateContactFormFailed,
    },
    "RWidget-RChat": {
      setLastSent: setRChatLastsent,
      setInput: setInputRchat,
      setValidateFailed: setValidateRchatFailed,
    },
    "RWidget-CustomButton": {
      setLastSent: setCustomButtonLastsent,
      setInput: setInputCustomButton,
      setValidateFailed: setValidateCustomButtonFailed,
    },
  };

  useEffect(() => {
    if (facebookConversionLastSent.result === 0 && facebookConversionLastSent.data.length > 0) {
      _forEach(facebookConversionLastSent.data, function (value, key) {
        const conversionMapping = conversionMappings[value.conversion_name];
        if (conversionMapping) {
          let { setLastSent, setInput, setValidateFailed } = conversionMapping;
          setLastSent(dateFormatter.formatDatetimeFull(value.last_sent_datetime, sessionStorage.getItem("lang")));

          if (value.conversion_value > 0) {
            value.conversion_value = parseFloat(value.conversion_value).toFixed(2);
            value.conversion_value = formatValue.formattedValueWithComma(value.conversion_value, 2);
            setInput(value.conversion_value);
            setValidateFailed(false);
          }
        }
      });
    }
  }, [facebookConversionLastSent]);

  useEffect(() => {
    getRwidgetConversionDefaultValue();
  }, []);

  const getRwidgetConversionDefaultValue = async () => {
    await dispatch(
      facebookActions.getRwidgetConversionDefaultValue({
        token: rmpToken,
      }),
    );
  };

  const getRwidgetConversionDefaultValueResult = useSelector((state) =>
    facebookSelectors.getRwidgetConversionDefaultValueResult(state),
  );

  useEffect(() => {
    if (getRwidgetConversionDefaultValueResult.result === 0 && getRwidgetConversionDefaultValueResult.data.length > 0) {
      _forEach(getRwidgetConversionDefaultValueResult.data, function (value, key) {
        const conversionMapping = conversionMappings[value.conversion_name];
        if (conversionMapping) {
          let { setInput, setValidateFailed, setLastSent } = conversionMapping;
          value.conversion_value = parseFloat(value.conversion_value).toFixed(2);
          value.conversion_value = formatValue.formattedValueWithComma(value.conversion_value, 2);
          setInput(value.conversion_value);
          setValidateFailed(false);
        }
      });
    }
  }, [getRwidgetConversionDefaultValueResult]);

  const validateInput = (input, widgetName) => {
    const regex = /^[0-9]*(\.[0-9]*)?$/;
    const isValid = regex.test(input);
    const conversionMapping = conversionMappings[widgetName];
    if (conversionMapping) {
      const { setValidateFailed } = conversionMapping;
      if (!isValid) {
        setValidateFailed(true);
      } else {
        setValidateFailed(false);
      }
    }
    return isValid;
  };

  const handleInputChange = (value, widgetName) => {
    const conversionMapping = conversionMappings[widgetName];
    if (conversionMapping) {
      const { setInput } = conversionMapping;
      if (value != "" && value != null && value != undefined) {
        let numericValue = value.replace(/[^\d.]/g, "");
        validateInput(value, widgetName);
        setInput(numericValue);
      } else {
        setInput("");
      }
    }
  };

  const handleFormatInputChange = (value, widgetName) => {
    const conversionMapping = conversionMappings[widgetName];
    if (conversionMapping) {
      const { setInput } = conversionMapping;
      if (value != "" && value != null && value != undefined) {
        let numericValue = value.replace(/[^\d.]/g, "");
        let formattedValueWithComma = formatValue.formattedValueWithComma(numericValue, 2);
        setInput(formattedValueWithComma);
      } else {
        setInput("");
      }
    }
  };

  useEffect(() => {
    if (rwidgetConversionDefaultValueResult.result === 0) {
      getRwidgetConversionDefaultValue();
    }
  }, [rwidgetConversionDefaultValueResult]);

  const validateInputSubmit = (inputValue, setShowFailedToast, setValidationState) => {
    if (!inputValue) {
      setShowFailedToast(true);
      setValidationState(true);
      return false;
    }
    return true;
  };

  const submit = async (e) => {
    setSubmitFBWidgetLoading(true);
    e.preventDefault();
    // validate data
    const validateInputResults = [
      validateInputSubmit(inputContactFrom, setShowFailedToast, setValidateContactFormFailed),
      validateInputSubmit(inputLine, setShowFailedToast, setValidateLineFailed),
      validateInputSubmit(inputFacebookMessenger, setShowFailedToast, setValidateFacebookMessengerFailed),
      validateInputSubmit(inputPhoneCall, setShowFailedToast, setValidatePhoneCallFailed),
      validateInputSubmit(inputCallbackForm, setShowFailedToast, setValidateCallBackFormFailed),
      validateInputSubmit(inputWhatApp, setShowFailedToast, setValidateWhatAppFailed),
      validateInputSubmit(inputSkype, setShowFailedToast, setValidateSkypeFailed),
      validateInputSubmit(inputGoogleMaps, setShowFailedToast, setValidateGoogleMapFailed),
      validateInputSubmit(inputZalo, setShowFailedToast, setValidateZaloFailed),
      validateInputSubmit(inputRchat, setShowFailedToast, setValidateRchatFailed),
      validateInputSubmit(inputCustomButton, setShowFailedToast, setValidateCustomButtonFailed),
      validateInputSubmit(inputTotalAction, setShowFailedToast, setValidateTotalActionFailed),
      validateInputSubmit(inputSmartConversion, setShowFailedToast, setValidateSmartConversionFailed),
    ];

    if (validateInputResults.some((result) => !result)) {
      setSubmitFBWidgetLoading(false);
      setShowFailedToast(true);
      return;
    } else {
      let data = {
        app_id: 1,
        pipelineSteps: [
          {
            conversionStatus: "active",
            conversion_name: "RWidget-ContactForm",
            conversion_value: formatValue.formattedValueWithoutComma(inputContactFrom, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-LINE",
            conversion_value: formatValue.formattedValueWithoutComma(inputLine, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-FacebookMessenger",
            conversion_value: formatValue.formattedValueWithoutComma(inputFacebookMessenger, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-PhoneCall",
            conversion_value: formatValue.formattedValueWithoutComma(inputPhoneCall, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-CallbackForm",
            conversion_value: formatValue.formattedValueWithoutComma(inputCallbackForm, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-WhatsApp",
            conversion_value: formatValue.formattedValueWithoutComma(inputWhatApp, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-Skype",
            conversion_value: formatValue.formattedValueWithoutComma(inputSkype, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-GoogleMaps",
            conversion_value: formatValue.formattedValueWithoutComma(inputGoogleMaps, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-Zalo",
            conversion_value: formatValue.formattedValueWithoutComma(inputZalo, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-RChat",
            conversion_value: formatValue.formattedValueWithoutComma(inputRchat, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-CustomButton",
            conversion_value: formatValue.formattedValueWithoutComma(inputCustomButton, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-TotalActions",
            conversion_value: formatValue.formattedValueWithoutComma(inputTotalAction, 2),
          },
          {
            conversionStatus: "active",
            conversion_name: "RWidget-SmartConversions",
            conversion_value: formatValue.formattedValueWithoutComma(inputSmartConversion, 2),
          },
        ],
      };

      const resultRwidget = await dispatch(facebookActions.rwidgetConversionDefaultValue({ token: rmpToken, ...data }));
      setSubmitFBWidgetLoading(false);
      setShowSuccessToast(true);
      setShowFailedToast(false);
    }
  };

  const successToastCallback = (value) => {
    if (showSuccessToast !== value) {
      setShowSuccessToast(value);
    }

    if (value === false && loading === true) {
      dispatch(googleActions.changeSettingPage("connected"));
    }
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const validateFailedToastCallback = (value) => {
    setShowValidateFailedToast(value);
  };

  const view = () => {
    return (
      <>
        <Description>{t("__fbads_widget_description")}</Description>
        <form>
          <Table>
            <thead>
              <tr>
                <th className="rwidget-title">R-Widget</th>
                <th className="facebook-ads-title" colSpan="2">
                  Meta Ads
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sub-title">{t("__ads_widget_action")}</td>
                <td className="sub-title">{t("__ads_widget_conversion_name")}</td>
                <td className="sub-title hideOnMobile" style={{ width: "100px" }}>
                  {t("__ads_crm_lead_conversion_value")}
                </td>
              </tr>

              {Object.keys(widgetConversionsList).map((key, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <IconContainer>
                        <Icon
                          className="widget-conversion-icon"
                          icon={widgetConversionsList[key].icon}
                          color={widgetConversionsList[key].color}
                        />
                        <span>{widgetConversionsList[key].title}</span>
                      </IconContainer>
                    </td>
                    <td>
                      <div>{key}</div>

                      <div className="hideOnDesktop">
                        <label className="secondary-text">{t("__ads_crm_lead_conversion_value")}</label>

                        <div>
                          {widgetConversionsList[key].name == "RWidget-ContactForm" ? (
                            <ValidatedInput
                              widgetName="inputContactFrom"
                              validationFailed={validateContactFormFailed}
                              value={inputContactFrom}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-LINE" ? (
                            <ValidatedInput
                              widgetName="inputLine"
                              validationFailed={validateLineFailed}
                              value={inputLine}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-FacebookMessenger" ? (
                            <ValidatedInput
                              widgetName="inputFacebookMessenger"
                              validationFailed={validateFacebookMessengerFailed}
                              value={inputFacebookMessenger}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-PhoneCall" ? (
                            <ValidatedInput
                              widgetName="inputPhoneCall"
                              validationFailed={validatePhoneCallFailed}
                              value={inputPhoneCall}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-CallbackForm" ? (
                            <ValidatedInput
                              widgetName="inputCallbackForm"
                              validationFailed={validateCallBackFormFailed}
                              value={inputCallbackForm}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-WhatsApp" ? (
                            <ValidatedInput
                              widgetName="inputWhatApp"
                              validationFailed={validateWhatAppFailed}
                              value={inputWhatApp}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-Skype" ? (
                            <ValidatedInput
                              widgetName="inputSkype"
                              validationFailed={validateSkypeFailed}
                              value={inputSkype}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-GoogleMaps" ? (
                            <ValidatedInput
                              widgetName="inputGoogleMaps"
                              validationFailed={validateGoogleMapFailed}
                              value={inputGoogleMaps}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-Zalo" ? (
                            <ValidatedInput
                              widgetName="inputZalo"
                              validationFailed={validateZaloFailed}
                              value={inputZalo}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-RChat" ? (
                            <ValidatedInput
                              widgetName="inputRchat"
                              validationFailed={validateRchatFailed}
                              value={inputRchat}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                          {widgetConversionsList[key].name == "RWidget-CustomButton" ? (
                            <ValidatedInput
                              widgetName="inputCustomButton"
                              validationFailed={validateCustomButtonFailed}
                              value={inputCustomButton}
                              onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                              onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="secondary-text">
                        {t("__ads_widget_action_last_update")}:{" "}
                        {widgetConversionsList[key].lastSend
                          ? widgetConversionsList[key].lastSend
                          : t("__fbads_conversion_no_data")}
                      </div>
                    </td>

                    <td className="text-right hideOnMobile">
                      {widgetConversionsList[key].name == "RWidget-ContactForm" ? (
                        <ValidatedInput
                          widgetName="inputContactFrom"
                          validationFailed={validateContactFormFailed}
                          value={inputContactFrom}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-LINE" ? (
                        <ValidatedInput
                          widgetName="inputLine"
                          validationFailed={validateLineFailed}
                          value={inputLine}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-FacebookMessenger" ? (
                        <ValidatedInput
                          widgetName="inputFacebookMessenger"
                          validationFailed={validateFacebookMessengerFailed}
                          value={inputFacebookMessenger}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-PhoneCall" ? (
                        <ValidatedInput
                          widgetName="inputPhoneCall"
                          validationFailed={validatePhoneCallFailed}
                          value={inputPhoneCall}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-CallbackForm" ? (
                        <ValidatedInput
                          widgetName="inputCallbackForm"
                          validationFailed={validateCallBackFormFailed}
                          value={inputCallbackForm}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-WhatsApp" ? (
                        <ValidatedInput
                          widgetName="inputWhatApp"
                          validationFailed={validateWhatAppFailed}
                          value={inputWhatApp}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-Skype" ? (
                        <ValidatedInput
                          widgetName="inputSkype"
                          validationFailed={validateSkypeFailed}
                          value={inputSkype}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-GoogleMaps" ? (
                        <ValidatedInput
                          widgetName="inputGoogleMaps"
                          validationFailed={validateGoogleMapFailed}
                          value={inputGoogleMaps}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-Zalo" ? (
                        <ValidatedInput
                          widgetName="inputZalo"
                          validationFailed={validateZaloFailed}
                          value={inputZalo}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-RChat" ? (
                        <ValidatedInput
                          widgetName="inputRchat"
                          validationFailed={validateRchatFailed}
                          value={inputRchat}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                      {widgetConversionsList[key].name == "RWidget-CustomButton" ? (
                        <ValidatedInput
                          widgetName="inputCustomButton"
                          validationFailed={validateCustomButtonFailed}
                          value={inputCustomButton}
                          onChange={(value) => handleInputChange(value, widgetConversionsList[key].name)}
                          onBlur={(value) => handleFormatInputChange(value, widgetConversionsList[key].name)}
                        />
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}

              <tr>
                <td>
                  <IconContainer>{t("__ads_widget_action_total_action")}</IconContainer>
                </td>
                <td>
                  <div>RWidget-TotalActions</div>

                  <div className="hideOnDesktop">
                    <label className="secondary-text">{t("__ads_crm_lead_conversion_value")}</label>
                    <ValidatedInput
                      widgetName="inputTotalAction"
                      validationFailed={validateTotalActionFailed}
                      value={inputTotalAction}
                      onChange={(value) => handleInputChange(value, "RWidget-TotalActions")}
                      onBlur={(value) => handleFormatInputChange(value, "RWidget-TotalActions")}
                    />
                  </div>

                  <div className="secondary-text">
                    {t("__ads_widget_action_last_update")}:{" "}
                    {totalActionLastsend ? totalActionLastsend : t("__fbads_conversion_no_data")}
                  </div>
                </td>
                <td className="hideOnMobile">
                  <ValidatedInput
                    widgetName="inputTotalAction"
                    validationFailed={validateTotalActionFailed}
                    value={inputTotalAction}
                    onChange={(value) => handleInputChange(value, "RWidget-TotalActions")}
                    onBlur={(value) => handleFormatInputChange(value, "RWidget-TotalActions")}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <IconContainer>{t("__ads_widget_action_behavior")}</IconContainer>
                </td>
                <td>
                  <div>RWidget-SmartConversions</div>

                  <div className="hideOnDesktop">
                    <label className="secondary-text">{t("__ads_crm_lead_conversion_value")}</label>
                    <ValidatedInput
                      widgetName="inputSmartConversion"
                      validationFailed={validateSmartConversionFailed}
                      value={inputSmartConversion}
                      onChange={(value) => handleInputChange(value, "RWidget-SmartConversions")}
                      onBlur={(value) => handleFormatInputChange(value, "RWidget-SmartConversions")}
                    />
                  </div>

                  <div className="secondary-text">
                    {t("__ads_widget_action_last_update")}:{" "}
                    {smartConversionLastsend ? smartConversionLastsend : t("__fbads_conversion_no_data")}
                  </div>
                </td>
                <td className="hideOnMobile">
                  <ValidatedInput
                    widgetName="inputSmartConversion"
                    validationFailed={validateSmartConversionFailed}
                    value={inputSmartConversion}
                    onChange={(value) => handleInputChange(value, "RWidget-SmartConversions")}
                    onBlur={(value) => handleFormatInputChange(value, "RWidget-SmartConversions")}
                  />
                </td>
              </tr>
            </tbody>
          </Table>

          <RowSticky>
            <RowAlignRight alignItems="stretch">
              <Button type="loading" onClick={(e) => submit(e)} loading={submitFBWidgetLoading}>
                {t("__ads_setup_save")}
              </Button>
            </RowAlignRight>
          </RowSticky>
        </form>
        <Toast
          show={showSuccessToast}
          message={t("__ads_setup_save_success")}
          bgColor="#4CAF50"
          callback={successToastCallback}
        ></Toast>
        <Toast
          show={showFailedToast}
          message={t("__ads_crm_conversion_conversion_value_not_valid")}
          bgColor="#F44336"
          callback={failedToastCallback}
        ></Toast>
        <Toast
          show={showValidateFailedToast}
          message={t("__ads_setup_validate_params_failed")}
          bgColor="#F44336"
          callback={validateFailedToastCallback}
        ></Toast>
      </>
    );
  };

  return view();
};

export default OfflineConversionWidget;

const Description = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  color: #999;
`;

const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #eee;
  width: 100%;
  font-size: 14px;

  th,
  td {
    border: 1px solid #eee;
    padding: 10px;
    width: 50%;
  }

  .rwidget-title {
    color: #fff;
    background-color: #2196f3;
  }

  .facebook-ads-title {
    color: #fff;
    background-color: #4caf50;
  }

  .sub-title {
    background-color: #f9f9f9;
    color: #555;
    /* font-size: 12px; */
    text-align: center;
    /* padding: 5px 10px; */
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }

  .text-center {
    text-align: center;
  }

  .hideOnDesktop {
    display: none;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .hideOnMobile {
      display: none;
    }

    .hideOnDesktop {
      display: block;
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0px;
`;

const Icon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  margin-right: 5px;

  &.widget-conversion-icon {
    background-image: url(${(props) => (props.icon ? props.icon : "/images/action.svg)")});
    background-color: ${(props) => (props.color ? props.color : "#9e9e9e")};
  }

  &.facebook_icon {
    background-image: url(/images/facebook.png);
    background-color: #2173f3;
  }
  &.line_icon {
    background-image: url(/images/line.png);
    background-color: #00b800;
  }
  &.click_to_call_icon {
    background-image: url(/images/click_to_call.png);
    background-color: #ff9c00;
  }
  &.contact_form_icon {
    background-image: url(/images/contact_form.png);
    background-color: #4cb48b;
  }
  &.action_icon {
    background-image: url(/images/action.svg);
    background-color: #ffffff;
    background-size: cover;
  }
`;

const InputInTable = styled(Input)`
  width: 100%;
  text-align: right;
  border: 1px solid #ddd; /* Set a default border */

  &:focus,
  &:active {
    outline: none;
    border: 1px solid #ddd !important; /* Increase specificity and use !important */
  }

  &.boxError {
    outline: none;
    border: 1px solid red; /* Set border color for boxError class */
  }

  &.boxError:focus,
  &.boxError:active {
    outline: none;
    border: 1px solid red !important; /* Increase specificity and use !important */
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    margin-top: 0px !important;
  }
`;

const RowAlignRight = styled(Row)`
  justify-content: flex-end;
`;

const RowSticky = styled.div`
  position: sticky;
  bottom: -16px;
  padding: 10px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #eee;

  @media screen and (min-width: 320px) and (max-width: 480px) {
    overflow-y: hidden;
    left: 0;
    right: 0;
    margin: 0px -16px;
  }
`;
